import React from 'react';
import DialogContent from '@mui/material/DialogContent';
import useDragToScroll from './useDragToScroll';

const dragScrollCursorStyles = {
  '&[data-drag-scroll-state="ready"]': {
    cursor: 'grab',
  },
  '&[data-drag-scroll-state="active"], &[data-drag-scroll-state="active"] *': {
    cursor: 'grabbing !important',
  },
};

const ViewerDialogContent = React.forwardRef(({ sx, ...props }, ref) => {
  const dragScrollHandlers = useDragToScroll();
  const contentStyles = Array.isArray(sx) ? sx : [sx];

  return (
    <DialogContent
      ref={ref}
      {...props}
      {...dragScrollHandlers}
      sx={[dragScrollCursorStyles, ...contentStyles.filter(Boolean)]}
    />
  );
});

ViewerDialogContent.displayName = 'ViewerDialogContent';

export default ViewerDialogContent;
